import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const OrdersPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        My Orders
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Orders page coming soon...
      </Typography>
    </Container>
  );
};

export default OrdersPage;
